// Class History - to check and fetch all the data related to past bookings
// Language: typescript
// Path: ClientApp\src\utils\history\index.ts

import { api } from "../../interfaces/interfaces";

export class JobHistory {
  private jobHistory: { [key: number]: any } = {};
  // async method to get the history of the job by jobId
  async getCompletions(jobId: number) {
    const completion = await api.fetchCompletedJobsByJobId(jobId);
    if (completion) this.jobHistory[jobId] = { ...this.jobHistory[jobId], completion };
  }

  // async method to get the reviews for the job by jobId
  async getReviews(jobId: number) {
    const review = (await api.fetchJobReviewsByJobId(jobId))
    if (review) {
      const { comments, dateTimeReviewed, score } = review;
      this.jobHistory[jobId] = { ...this.jobHistory[jobId], review: { comments, dateTimeReviewed, score } };
    }
  }

  // async method to get past calls from source number
  async getPastCalls(phoneNumber: string, jobId: number) {
    if (phoneNumber) {
      const pastCalls = await api.fetchCallEventsBySource(phoneNumber);
      if (pastCalls) {
        const processed = await Promise.all(
          pastCalls.map(async (call) => {
            const { source, destination: target, additional_source, dte_start: callStarted } = call;
            const event = (await api.fetchEvents({ internal_iq_session_id: call.internal_iq_session_id ?? "" }))?.[0];
            if (event) {
              const { accountCode, destination, queue_key } = event;
              return { source, target, destination, callStarted, accountCode, queue_key, additional_source };
            } else return { source, target, callStarted, additional_source };
          })
        );

        if (processed) this.jobHistory[jobId] = { ...this.jobHistory[jobId], pastCalls: processed };
      }
    }
  }

  async searchHistory(search: string) {
    const data = await api.fetchTop5Calls(search);
    if (data) {
      console.log(data, "searchHistory");
    }
  }

  // async method to check if the job is in the history
  async checkHistory({
    postcode,
    property,
    telephoneMobile,
    telephoneLandline,
    emailAddress,
  }: {
    postcode?: string;
    property?: string;
    telephoneMobile?: string;
    telephoneLandline?: string;
    emailAddress?: string;
  }) {
    const response = await api.fetchLast2({ postcode, property, telephoneMobile, telephoneLandline, emailAddress });
    telephoneMobile && (await api.fetchCallHistoryBySource({ source: telephoneMobile }));
    telephoneLandline && (await api.fetchCallHistoryBySource({ source: telephoneLandline }));

    if (response && response.length > 0) {
      // for job in response get history
      for (const job of response) {
        if (job && job.jobId)
          this.jobHistory[job.jobId] = { ...this.jobHistory, job };
        // await this.getCompletions(job.jobId);
        // await this.getReviews(job.jobId);
        // await this.getPastCalls(telephoneMobile || telephoneLandline || "", job.jobId);
      }
    }
    // else {
    //   await this.searchHistory(String(telephoneMobile || telephoneLandline));
    // }
  }
}

const HistoryUtils = new JobHistory();

// define global variable history
(window as any).HistoryUtils = HistoryUtils;

export default HistoryUtils;
